module.exports = __webpack_public_path__ + "img/splicing_prograss_four_s.f63fcac4.png";